import { useState } from "react";
import { NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import ThemeToggle from "../ThemeToggle";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/project-testing", label: "Case Study" },
  { to: "/postman", label: "API Testing" },
  { to: "/dbeaver", label: "SQL Analysis" },
  { to: "/qa-project-collection", label: "GoIT QA Program" },
  { to: "/certificates", label: "Certificates" },
];

function HamburgerIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <line x1="2" y1="4" x2="16" y2="4" />
      <line x1="2" y1="9" x2="16" y2="9" />
      <line x1="2" y1="14" x2="16" y2="14" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <line x1="2" y1="2" x2="14" y2="14" />
      <line x1="14" y1="2" x2="2" y2="14" />
    </svg>
  );
}

function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);

  const getLinkClassName = ({ isActive }) =>
    `nav-link ${isActive ? "nav-link-active" : ""}`;

  return (
    <header className="shell-container pt-4 sm:pt-6">
      <div className="shell-panel sticky top-4 z-50 flex items-center justify-between px-4 py-3 sm:px-6">
        <NavLink
          to="/"
          end
          className="min-w-0"
          onClick={() => setMenuOpen(false)}
        >
          <span className="block font-mono text-[11px] uppercase tracking-[0.22em] text-muted">
            Technical Sandbox
          </span>
          <span className="mt-1 block truncate text-sm font-semibold text-ink sm:text-base">
            Yaroslav Podonin
          </span>
        </NavLink>

        <nav className="hidden items-center gap-2 lg:flex" aria-label="Primary">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={getLinkClassName}
            >
              {item.label}
            </NavLink>
          ))}
          <a
            href="https://github.com/ypodonin"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
          >
            GitHub
          </a>
          <ThemeToggle />
        </nav>

        <div className="flex items-center gap-2 lg:hidden">
          <ThemeToggle />
          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-line bg-surface text-ink"
            aria-expanded={menuOpen}
            aria-controls="mobile-navigation"
            aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          >
            {menuOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.nav
            id="mobile-navigation"
            aria-label="Mobile"
            initial={{ opacity: 0, y: -6 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -6 }}
            transition={{ duration: 0.16, ease: "easeOut" }}
            className="shell-panel mt-3 flex flex-col gap-1 p-3 lg:hidden"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={getLinkClassName}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href="https://github.com/ypodonin"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
              onClick={() => setMenuOpen(false)}
            >
              GitHub
            </a>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
}

export default SiteHeader;
